import React, { useEffect } from "react";
import { connect } from "react-redux";
import Traec from "traec";
import CompanyInviteItem from "./companyInviteItem";

function CompanyInvites({ items }) {
  // Fetch data when component mounts
  useEffect(() => {
    const requiredFetches = [new Traec.Fetch("company_invite_all", "list")];
    Traec.fetchRequired(requiredFetches);
  }, []);

  if (!items || !items.size) {
    return (
      <div className="list-group-item text-center py-4">
        <p className="text-muted mb-0">No company invitations</p>
      </div>
    );
  }

  const itemList = items.toList().map((item, i) => <CompanyInviteItem key={i} index={i} invite={item} />);

  return <div className="list-group list-group-flush">{itemList}</div>;
}

const mapStateToProps = (state, ownProps) => {
  const rawCompanyInvites = state.getInPath("entities.companyInvites.byId");
  const filteredItems = rawCompanyInvites?.filter((i) => i?.getInPath("company.name"));

  return {
    items: filteredItems,
    isAuthenticated: state.getInPath("auth.isAuthenticated"),
  };
};

export default connect(mapStateToProps)(CompanyInvites);
